<div class="container">
  <header><br>

      <!-- <div >
          <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
               
              </ol>
            </nav>
         </div> -->
  </header>
  <div class="row">
      <div class="col-sm-6">
        <div class="card card-1">
          
            <a [routerLink]="['/hsscstudents']"  class="btn btn-primary">HSSC Auguest 2020</a>
            <!-- <a (click)=toggleDisplayDiv() class="btn btn-primary">HSSC Auguest 2020</a> -->
            <!-- <a (click)="showDiv.previous = !showDiv.previous;showDiv.current = false;showDiv.next = false" class="btn btn-primary">HSSC Auguest 2020</a> -->
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card card-3">
          
          <a [routerLink]="['/sscstudents']" class="btn btn-primary">SSC Octomber 2020</a>
          <!-- <a (click)=sscResult() class="btn btn-primary">SSC Octomber 2020</a> -->
          <!-- <div class="card-body">
            <h5 class="card-title">HSSC Student</h5>
            <p class="card-text">Total HSSC Student</p>
            <a href="#" class="btn btn-primary">Go somewhere</a>
          </div> -->
        </div>
      </div>
    </div>
    <br><br>
    <!-- <div [hidden]="isShowDiv">
      test
    </div> -->
    <!-- <div *ngIf="showDiv.previous"> -->
      <div >
      <h5 style="text-align: center;"><u>SSC Results</u></h5>
             
      <form role="form" [formGroup]="selctform" (submit)="onStudentdatassc()">
          <div class="row">
              <div class="col-md-3">
                  <div class="form-group">
                    <input id="erno"  formControlName="erno"  placeholder="ER NO"  class="form-control" type="text" value=""  >
                      
                  </div>
                  
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <input id="seat"  formControlName="seat"  placeholder="SEAT NO"  class="form-control" type="text" value=""  >
                      
                  </div>
                  
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <input id="scode"  formControlName="scode"  placeholder="SCODE"  class="form-control" type="text" value=""  >
                      
                  </div>
                  
                </div>
                <div class="col-md-3" style="margin-top:-25px;">
                  <div class="form-group">
                      <button type="submit" class="btn btn-primary my-4" >Get Result</button>   
                    </div>
                 
              </div>
          </div>
          <br>
          
      </form>
  </div>
  
  <div *ngIf="showDiv.current">
    <h5 style="text-align: center;"><u>HSSC Results</u></h5>
              <br>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            HSSC - {{exam}}
          </div>
          <div class="card-body">
            <h5 class="card-title">Seat No : {{seat}}</h5>
            <h5 class="card-title">Stream  &nbsp;&nbsp;: {{stream}}</h5>
            <h5 class="card-title">Name    &nbsp;&nbsp;&nbsp;&nbsp;: {{stname}}</h5><br>
            
            <table class="table table-striped table-bordered table-sm row-border hover" >
                <thead>
                  <tr>
                    <th rowspan="2">Subject</th>
                    <th colspan="3">Theory</th>
                    <th colspan="3">Practical/Oral</th>
                    <th rowspan="2">Total Marks & Grade</th>
                  </tr>
                  <tr>
                    <td>External Marks & Grade</td>
                    <td>Internal Marks</td>
                    <td>Overall Marks & Grade</td>
                    <td>External Marks</td>
                    <td>Internal Marks</td>
                    <td>Overall Marks & Grade</td>
                   
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{s1name}}</td>
                    <td> {{s1thext}} {{s1thextg}}</td>
                    <td>{{s1thint}}</td>
                    <td>{{sb1x}} {{sb1gr}}</td>
                    <td>{{sb1p}}</td>
                    <td>{{sb1pit}}</td>
                    <td>{{sb1prc}}</td>
                    <td>{{sb1x}} {{sb1gr}}</td>
                  </tr>
                  <tr>
                    <td>{{s2name}}</td>
                    <td> {{s2thext}} {{s2thextg}}</td>
                    <td>{{s2thint}}</td>
                    <td>{{sb2x}} {{sb2gr}}</td>
                    <td>{{sb2p}}</td>
                    <td>{{sb2pit}}</td>
                    <td>{{sb2prc}}</td>
                    <td>{{sb2x}} {{sb2gr}}</td>
                  </tr>
                  <tr>
                    <td>{{s3name}}</td>
                    <td> {{s3thext}} {{s3thextg}}</td>
                    <td>{{s3thint}}</td>
                    <td>{{sb3x}} {{sb3gr}}</td>
                    <td>{{sb3p}}</td>
                    <td>{{sb3pit}}</td>
                    <td>{{sb3prc}}</td>
                    <td>{{sb3x}} {{sb3gr}}</td>
                  </tr>
                  <tr>
                    <td>{{s4name}}</td>
                    <td> {{s4thext}} {{s4thextg}}</td>
                    <td>{{s4thint}}</td>
                    <td>{{sb4x}} {{sb4gr}}</td>
                    <td>{{sb4p}}</td>
                    <td>{{sb4pit}}</td>
                    <td>{{sb4prc}}</td>
                    <td>{{sb4x}} {{sb4gr}}</td>
                  </tr>
                  <tr>
                    <td>{{s5name}}</td>
                    <td> {{s5thext}} {{s5thextg}}</td>
                    <td>{{s5thint}}</td>
                    <td>{{sb5x}} {{sb5gr}}</td>
                    <td>{{sb5p}}</td>
                    <td>{{sb5pit}}</td>
                    <td>{{sb5prc}}</td>
                    <td>{{sb5x}} {{sb5gr}}</td>
                  </tr>
                  <tr>
                    <td>{{s6name}}</td>
                    <td> {{s6thext}} {{s6thextg}}</td>
                    <td>{{s6thint}}</td>
                    <td>{{sb6x}} {{sb6gr}}</td>
                    <td>{{sb6p}}</td>
                    <td>{{sb6pit}}</td>
                    <td>{{sb6prc}}</td>
                    <td>{{sb6x}} {{sb6gr}}</td>
                  </tr>
                  <tr>
                    <td>{{s7name}}</td>
                    <td> {{s7thext}} {{s7thextg}}</td>
                    <td>{{s7thint}}</td>
                    <td>{{sb7x}} {{sb7gr}}</td>
                    <td>{{sb7p}}</td>
                    <td>{{sb7pit}}</td>
                    <td>{{sb7prc}}</td>
                    <td>{{sb7x}} {{sb7gr}}</td>
                  </tr>
                  <tr>
                    <td colspan="6">Result</td>
                    <td>{{result}}</td>
                    <td>{{ttl}}</td>
                  </tr>
                </tbody>
            </table>
          </div>
        </div>
          
      </div>
  </div>
  </div>


</div>